<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>机构部门管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <!-- <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.deptNameLike" placeholder="请输入部门名称"></el-input>
            </el-form-item> -->
            <el-form-item>
                <!-- <el-button size="small" type="primary" @click="search()">搜索</el-button> -->
                <el-button size="small" type="primary" v-buttonAuth="'system:dept:add'"
                    @click="handleEdit()">新建一级部门</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading"
                @selection-change="handleSelectionChange" @row-click="handleRowClick" :tableConfig="tableForm.tableConfig">
                <template #deptPeopleNum="item">
                    <div class="col-29f cs-pit" @click="goUser(item.row)">
                        {{ item.row.deptPeopleNum }}
                    </div>
                </template>
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
                            v-buttonAuth="'system:dept:edit'">编辑</el-button>
                        <el-button type="text" @click="childrenDialog(scope.row)"
                            v-buttonAuth="'system:dept:add'">添加子部门</el-button>
                        <el-popconfirm title="确认删除吗？" @confirm="removeDept(scope.$index, scope.row)">
                            <el-button type="text" slot="reference" class="col-f4d"
                                v-buttonAuth="'system:dept:delete'">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog :title="title" :visible.sync="editFormVisible" :close-on-click-modal="false" custom-class="form-dialog"
            width="70%" @close='closeDialog()'>
            <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules"
                @submit="submitForm" :dataForm="formConfig.dataForm">
            </my-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='editFormVisible=false'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import { deptAdd, deptEdit, deptRemove, deptDetail, deptTreePage, deptMemberPage } from '@/api/dept.js'
export default {
    components: {
        MyTable,
        Pagination,
        myForm,
    },
    data () {
        return {
            formInline: {
                deptNameLike: '',
            },
            tableForm: {
                customColumns: [
                    { label: '部门名称', prop: 'deptName' },
                    { label: '部门编码', prop: 'deptNo' },
                    { label: '部门负责人', prop: 'deptLeaderName' },
                    { label: '部门职员', prop: 'deptPeopleNum', slot: 'deptPeopleNum' },
                ],
                tableConfig: {
                    'row-key': "deptId",
                    'tree-props': { children: 'children', hasChildren: 'hasChildren' }
                },
                tableData: [

                    // ...其他数据
                ],
                isLoading: false,
            },
            dialogVisible: false,
            dialogImageUrl: '',

            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            editFormVisible: false, //控制编辑页面显示与隐藏
            title: '添加用户',
            // 编辑与添加
            formConfig: {
                formItems: [
                    { type: 'input', prop: 'deptNo', label: '部门编码' },
                    { type: 'input', prop: 'deptName', label: '部门名称' },
                    {
                        type: 'select', prop: 'deptLeaderId', label: '部门负责人', options: []
                        , property: {
                            clearable: true,
                            filterable: true,
                        },
                    },
                    { type: 'textarea', prop: 'deptDesc', label: '部门介绍' },

                    // Add more form items as needed
                ],
                formRules: {
                    deptNo: [
                        { required: true, message: '请输入部门编码', trigger: 'blur' },
                        // 可以添加其他验证规则
                    ],
                    deptName: [
                        { required: true, message: '请输入部门名称', trigger: 'blur' },
                        // 可以添加其他验证规则
                    ],
                },
                dataForm: {
                    deptNo: '',
                    deptName: '',
                    deptDesc: '',
                    deptLeaderId: null,
                    pId: 0,
                }
            },
        }
    },
    created () {
        this.getData();
    },
    methods: {
        async getData () {
            this.tableForm.checkList = [];
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                deptNameLike: this.formInline.deptNameLike
            }
            const res = (await deptTreePage(params)).data;
            this.tableForm.tableData = res.records;
            this.pageparm.total = res.total
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData()
        },
        handleSelectionChange (selection) {
            console.log('选择发生变化：', selection);
        },
        handleRowClick (row) {
            console.log('点击行：', row);
        },
        goUser (row) {
            this.$router.push({
                path: '/basic/DeptUser',
                query: {
                    deptId: row.deptId,
                    name: row.deptName
                }
            })
        },
        async handleEdit (index, row) {
            this.editFormVisible = true
            if (row != undefined && row != 'undefined') {
                this.formConfig.formItems[2].hide = false;
                this.title = '修改部门'
                const params = {
                    pageNum: 1,
                    pageSize: 99999,
                    deptId: row.deptId

                }
                this.formConfig.dataForm = JSON.parse(JSON.stringify(row));
                const res = (await deptMemberPage(params)).data;
                this.formConfig.formItems[2].options = res.records.map(res => {
                    return {
                        id: res.archiveId,
                        label: res.userName,
                    }
                });
                this.formConfig.formItems[0].disable = true;
                if (!this.formConfig.formItems[2].options.some(el => el.id === row.deptLeaderId)) {
                    this.formConfig.formItems[2].options.push({
                        id: row.deptLeaderId,
                        label: row.deptLeaderName,
                        disabled: true,
                    })
                }


            } else {
                this.formConfig.formItems[2].hide = true;
                this.title = '新增一级部门'
                this.formConfig.dataForm = {
                    deptNo: '',
                    deptName: '',
                    deptLeaderId: null,
                    deptDesc: '',
                    pid: 0,
                }
            }
        },
        childrenDialog (row) {
            this.formConfig.formItems[2].hide = true;
            this.editFormVisible = true;
            this.title = '新增子部门'
            this.formConfig.dataForm = {
                deptNo: '',
                deptName: '',
                deptDesc: '',
                pid: row.deptId,
            };

        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize;
            this.getData()
        },
        async removeDept (index, row) {
            const deptRes = await deptRemove([row.deptId]);
            this.$message.success(deptRes.msg);
            this.getData();
        },
        // 关闭编辑、增加弹出框
        closeDialog (dialog) {
            this.formConfig.dataForm = {
                deptNo: '',
                deptName: '',
                deptDesc: '',
                pid: null,
            }
            this.formConfig.formItems[0].disable = false;
            console.log(this.formConfig.formItems[0]);
            this.$refs.editForm.$refs.form.resetFields();
            this.$forceUpdate()
            this.editFormVisible = false;
            this.getData()
        },
        async submitForm (editData) {
            const data = this.formConfig.dataForm;
            this.$refs.editForm.$refs.form.validate(async valid => {
                if (valid) {
                    delete data.deptLeaderName;
                    const res = await (data.deptId ? deptEdit(data) : deptAdd(data));
                    this.closeDialog();
                    await this.getData();
                    this.$message.success(res.msg);
                    // 请求方法
                } else {
                    return false
                }
            })
        },


    },

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/basicData/department.vue